import { render, staticRenderFns } from "./JournalDetails.vue?vue&type=template&id=7c124a87&"
import script from "./JournalDetails.vue?vue&type=script&lang=js&"
export * from "./JournalDetails.vue?vue&type=script&lang=js&"
import style0 from "./JournalDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports